
import React from "react";
import {ISupportedPlatformsWrapper} from "../interfaces";


export interface ISupportedPlatformsProps {
    supportedPlatformsWrapper?:ISupportedPlatformsWrapper
}
/**
 * the entry point
 */
const TabSupportedPlatformsMobile = (props?: ISupportedPlatformsProps) => {
    const supportedPlatformsWrapper = props?.supportedPlatformsWrapper;
    const sp = supportedPlatformsWrapper?.supportedPlatforms[0];

    return (
        <div className="my-4">
            {supportedPlatformsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: supportedPlatformsWrapper?.topBanner }} />}
            {supportedPlatformsWrapper != null && supportedPlatformsWrapper.supportedPlatforms.length > 0 &&
                <ul className="bullet">
                    {sp?.mostAudioHosts && <li>Most Audio Hosts. Check the Supported Hosts list above</li>}
                    {/*StudioVerse*/}
                    {sp?.studioVerseAudioEffects && sp?.studioVerseInstruments && <li>StudioVerse</li>}
                    {!sp?.studioVerseAudioEffects && sp?.studioVerseInstruments && <li>StudioVerse Instruments Only</li>}
                    {sp?.studioVerseAudioEffects && !sp?.studioVerseInstruments && <li>StudioVerse Audio Effects Only</li>}

                    {/*SuperRack*/}
                    {(sp?.superRackNative == sp?.superRackSoundGrid && sp?.superRackNative === true) &&
                        <li>SuperRack</li>}
                    {(sp?.superRackNative !== sp?.superRackSoundGrid && sp?.superRackNative === true) &&
                        <li>SuperRack Performer</li>}

                    {sp?.eMotionLV1Mixer && <li>eMotion LV1 Mixer</li>}
                    {sp?.eMotionSTMixer && <li>eMotion ST Mixer</li>}

                    {/*StudioRack*/}
                    {(sp?.studioRackNative === sp?.studioRackSoundGrid && sp?.studioRackNative === true) &&
                        <li>StudioRack - the latest StudioRack and plugins supported version is V14</li>}
                    {(sp?.studioRackNative !== sp?.studioRackSoundGrid && sp?.studioRackNative === true) &&
                        <li>StudioRack Native Only - the latest StudioRack and plugins supported version is V14</li>}

                    {/*MultiRack*/}
                    {(sp?.multiRackNative === sp?.multiRackSoundGrid && sp?.multiRackNative === true) &&
                        <li>MultiRack</li>}
                    {(sp?.multiRackNative !== sp?.multiRackSoundGrid && sp?.multiRackNative === true) &&
                        <li>MultiRack Native</li>}

                    {sp?.diGiCo && <li>DiGiCo SD (v929 or earlier) with MultiRack (v9.8 or earlier) embedded</li>}
                    {sp?.venue &&
                        <li>Avid VENUE 5.7 or later when used with <a href='/mixers-racks/soundgrid-rack-for-venue'
                                                                      className='' title='SoundGrid Rack for VENUE'>SoundGrid
                            Rack for VENUE</a>. For plugins for VENUE V3–3.1.1, <a
                            href='/support/avid-venue-v3-compatible-plugins' className='' title='see here'>see here</a>.
                        </li>}
                </ul>
            }
            {supportedPlatformsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: supportedPlatformsWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabSupportedPlatformsMobile;